import { type TPageFormatting, usePageFormattingOptions, useUpdatePageFormatting } from "../../../../data";
import type { TRangeSelection } from "../../useRangeSelectionChange";
import { useGrid } from "../../stores";
import { useAddAction } from "../ModalContainer";
import { getCellIds, modalTypeToHighlightType, type TFormatTypes } from "../../cell-style/helpers";

export const useUpdateFormatting = ({
  pageId,
  type,
  selection,
}: {
  pageId: string;
  type: TFormatTypes;
  selection: TRangeSelection;
}) => {
  const formatting = usePageFormattingOptions(pageId);
  const updateFormatting = useUpdatePageFormatting();
  const [api] = useGrid();

  const highlightType = modalTypeToHighlightType(type);
  const highlights = { ...(formatting.data?.[highlightType] ?? {}) };
  const { cellIds } = getCellIds({ type, ranges: selection, api });
  const actions = useAddAction();

  const onChange = (value: Partial<TPageFormatting[string]>) => {
    if (!actions.hasCancel()) {
      const current = structuredClone({ ...formatting.data });
      actions.onCancel(() => updateFormatting({ id: pageId, ...current }));
    }
    for (const cellId of cellIds) {
      highlights[cellId] = {
        color: highlights[cellId]?.color,
        boldText: highlights[cellId]?.boldText || false,
        invertTextColor: highlights[cellId]?.invertTextColor || false,
        ...value,
      };
    }
    updateFormatting({ id: pageId, [highlightType]: highlights });
  };

  const value = highlights[cellIds[0]] ?? {};

  return [value, onChange] as const;
};
